import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import PropTypes from 'prop-types';
import { LinearProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
// API
import { toast } from 'react-toastify';
import { postDeleteAttachment } from '../../../api/ccoApi';

export default function AttachmentStepper({
  attachment,
  loadingAttachment,
  setLoadingAttachment,
  readOnly,
}) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [attachments, setAttachments] = useState(attachment);

  let maxSteps = attachments?.length;

  const fileAttachment = ['pdf', 'ppt', 'pptm', 'csv', 'xlsx', 'xls', 'pptx'];
  const otherFile = ['csv', 'xlsx', 'xls', 'pptx'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleDeleteAttachment = async (value) => {
    const { isConfirmed } = await Swal.fire({
      title: 'Delete',
      text: `Are you sure you want to delete attachment?`,
      icon: 'warning',
      showCancelButton: true,
    });

    if (!isConfirmed) {
      return;
    }

    setLoadingAttachment(true);
    toast.loading('Processing request please wait...');
    const request = {
      id: value,
    };

    const response = await postDeleteAttachment(request);
    const { code, data, message } = response.data;

    if (code === '200') {
      setActiveStep(0);
      maxSteps = data.length;
      toast.dismiss();
      // const newAttachment = attachments.filter((row) => row.id !== value);
      setAttachments(data);
      toast.success(message);
      setLoadingAttachment(false);
    }
  };

  useEffect(() => {
    setAttachments(attachment);
  }, [attachment]);
  return (
    <Grid container>
      <Grid item md={12}>
        {loadingAttachment ? (
          <LinearProgress />
        ) : (
          <Box sx={{ height: 'auto', width: 'auto' }} pt={2}>
            <Box display='flex' alignItems='center' justifyContent='center'>
              {fileAttachment.includes(attachments[activeStep]?.file_type) ? (
                <iframe
                  title={attachments[activeStep]?.file_name || 'No file'}
                  // src={attachments[activeStep]?.file_path}
                  src={
                    otherFile.includes(attachments[activeStep]?.file_type)
                      ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                          attachments[activeStep]?.file_path,
                        )}`
                      : `https://docs.google.com/gview?url=${encodeURIComponent(
                          attachments[activeStep]?.file_path,
                        )}&embedded=true`
                  }
                  style={{
                    height: '300px',
                    width: '100%',
                  }}
                />
              ) : (
                <Box
                  component='img'
                  sx={{
                    height: '30%',
                    width: '60%',
                  }}
                  // src={attachments[activeStep].file_path}
                  // alt={attachments[activeStep].file_name}
                  src={attachments[activeStep]?.file_path || ''}
                  alt={attachments[activeStep]?.file_name || 'No file'}
                />
              )}
            </Box>
            {readOnly ? null : (
              <Box display='flex' alignItems='center' justifyContent='center' pt={2}>
                <Button
                  variant='contained'
                  color='error'
                  endIcon={<DeleteIcon />}
                  onClick={() => handleDeleteAttachment(attachments[activeStep]?.id)}
                >
                  Delete
                </Button>
              </Box>
            )}
            <Box ml={4}>
              <MobileStepper
                sx={{ marginLeft: '100px' }}
                variant='text'
                steps={maxSteps}
                position='static'
                activeStep={activeStep}
                nextButton={
                  <Button size='small' onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                    Next
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                  </Button>
                }
                backButton={
                  <Button
                    sx={{ marginLeft: '-150px' }}
                    size='small'
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                    Back
                  </Button>
                }
              />
            </Box>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}

AttachmentStepper.defaultProps = {
  attachment: [],
  loadingAttachment: false,
  setLoadingAttachment: () => {},
  readOnly: false,
};

AttachmentStepper.propTypes = {
  attachment: PropTypes.array?.isRequired,
  loadingAttachment: PropTypes.bool,
  setLoadingAttachment: PropTypes.func,
  readOnly: PropTypes.bool,
};
